import { memo } from 'react';
import useChartUpdate from '../UseChartUpdate';
var LegendTitle = /*#__PURE__*/memo(function (props) {
  useChartUpdate(props, updateLegendTitle, function (chart) {
    return updateLegendTitle(chart, {
      text: null
    });
  });
  return null;
});

var updateLegendTitle = function updateLegendTitle(chart, config) {
  chart.update({
    legend: {
      title: config
    }
  }, false);
};

LegendTitle.displayName = 'LegendTitle';
export default LegendTitle;